import ReactDOM from 'react-dom/client'
import isBetween from 'dayjs/plugin/isBetween'
import isLeapYear from 'dayjs/plugin/isLeapYear'
import relativeTime from 'dayjs/plugin/relativeTime'
import duration from 'dayjs/plugin/duration'
import './index.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { setScreenInfo } from './utils/css'
import initECharts from '@/initECharts'
import dayjs from 'dayjs'
import { workStore } from './store'
import { killConsole } from '@/utils'

import './intl'
import { EventEmitter } from '@/utils/event'
import Api from '@/server'

dayjs.extend(duration)
dayjs.extend(isBetween)
dayjs.extend(isLeapYear)
dayjs.extend(relativeTime)

setScreenInfo()
initECharts()
workStore.initStore()

window.addEventListener('resize', setScreenInfo)

let loopInterval: any = null

const loopGetNotification = async () => {
    if (loopInterval) {
        return
    }
    getNotification()
    loopInterval = setInterval(
        async () => {
            getNotification()
        },
        window.location.href.indexOf('localhost') > -1 ? 100000000000 : 10000,
    )
}

const playNotificationSound = () => {
    if (localStorage.getItem('withdrawNotification') === 'true') {
        const audio = new Audio('/sounds/withdraw_notification.mp3')
        audio.play().catch((err) => console.warn(err))
    }
}

const getNotification = () => {
    Api.post('/userManage/depositNotification', {}, { showError: false }).then((res) =>
        workStore.setDepositNotification(res ?? 0),
    )
    Api.post('/userManage/withdrawNotification', {}, { showError: false }).then((res) => {
        if (res > workStore.withdrawNotification) {
            playNotificationSound()
        }
        workStore.setWithdrawNotification(res ?? 0)
    })
    Api.post('/userManage/onlineNotification', {}, { showError: false }).then((res) =>
        workStore.setOnlineNotification(res ?? 0),
    )
}

const stopLoopGetNotification = () => {
    clearInterval(loopInterval)
    loopInterval = null
}

EventEmitter.on('loopGetNotification', loopGetNotification)
EventEmitter.on('stopLoopGetNotification', stopLoopGetNotification)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)

reportWebVitals()
if (process.env.REACT_APP_ENV === 'PROD') {
    killConsole()
} else {
    document.title = '后台-3D-测试'
}
